<div [ngClass]="{ float: float }">
  <div [className]="centered ? 'center-all' : ''">
    <div class="lds-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  @if (message) {
    <div [className]="centered ? 'alert alert-info center-all mt-2' : 'alert alert-info mt-2'">{{ message }}</div>
  }
  @if (messagesByKey) {
    <div>
      @for (message of messagesByKey.values(); track $index) {
        <div [className]="centered ? 'alert alert-info center-all mt-2' : 'alert alert-info mt-2'">{{ message }}</div>
      }
    </div>
  }
</div>
